import { createRouter, createWebHistory } from "vue-router";
import MovieMain from "@/views/MovieMain.vue";

const routes = [
  {
    path: "/",
    name: "MovieMain",
    component: MovieMain,
  },
  {
    path: "/about",
    name: "About",
    component: function () {
      return import("@/views/About.vue");
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
